var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetworking = function SvgNetworking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Networking_svg__a",
    d: "M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Networking_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Networking_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Networking_svg__a",
    fill: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Networking_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M69.891 45.389c-2.844-3.727-6.487-6.497-6.487-6.497l-9.411 2.13s-4.669 3.16-5.773 4.367c-1.163 2.484-.942 19.756-.942 19.756s.874 3.366 8.252 4.464c11.486 1.708 11.37-4.464 11.37-4.464s5.094-17.414 2.991-19.756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDFBFC",
    d: "M64 37.578s-3.88 4.385-7.62 4.266c-3.291-.105-2.672-2.333-2.672-2.333l9.486-2.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E7",
    d: "M60.78 26.916s.687 6.57-1.922 9.038-14.326-5.305-13.527-8.224c.32-1.169 2.61-1.92 2.335-4.25s.55-11.17.55-11.17 10.299-.206 12.77 3.906 1.992 7.676 1.992 7.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A2DE",
    d: "m61.467 28.062 1.056 10.47s-2.321 2.396-4.966 3.139-3.656-1.114-3.656-1.114l-.24-4.223s4.3.099 5.529-3.27c1.228-3.368.857-4.823.857-4.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DCD",
    d: "M52.23 30.11s4.959 1.152 5.965 0 .892-5.002.892-5.002l2.066.347.385.825-.768 1.108s1.224 7.612-2.201 8.754c-9.349 3.12-9.677-.277-10.761-1.865-.656-.96-1.531-3.57-1.531-3.57.86.555.998 1.205 2.992.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    d: "M61.401 26.092s-2.075-.283-2.075-.522c0-.238.213-3.214.497-4.595s1.635-2.975.996-4.18c-.64-1.204-7.068-2.408-7.068-2.408s-1.638 3.542-4.96 3.542-5.206-4.25-3.11-7.296 4.371-.886 4.371-.886 1.315-1.31 2.878-.743c1.564.566 3.092 2.868 3.092 2.868s4.548 2.385 6.111 5.248c.555 1.017 3.528 1.51 2.71 3.308a10.7 10.7 0 0 0-.895 3.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E7",
    d: "M61.205 24.313s1.718-.479 2.347.084c.629.564 1.04 3.465.92 4.338-.122.873-1.616 1.296-3.267 1.296-1.258 0-1.005-.255-1.005-.255s-.688-3.624 1.005-5.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DCD",
    d: "M18.02 31.894c-1.472-4 .082-6.637-.342-9.42s2.648-5.234-1.611-7.924c-1.94-1.225-4.613-.554-6.521-.163a7 7 0 0 0-.357.082c-2.118.511-7.418 1.176-9.108 4.146-1.359 2.389-1.297 4.036-4.067 10.228-2.03 4.534-5.325 17.823 2.77 17.18 5.602 2.891 23.636-3.853 19.236-14.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    d: "M1.237 63.29c.797-8.537-2.355-15.546-1.468-18.786 1.254-4.577 5.237-4.035 5.237-4.035l5.156.862s3.997 1.942 4.763 5.106-.759 16.045-.759 16.045-1.976 2.212-6.285 2.671q-5.28.563-6.644-1.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F18700",
    d: "m6.175 32.985-.76 7.31s1.59 2.463 3.456 2.533c1.867.07 2.67-1.393 2.402-2.145-1.22-3.423-.662-6.885-.662-6.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.97 40.427s.846-2.015 2.287-3.012c1.837 2.23 2.515 4.801 5.097 8.37-2.682-.08-5.531-2.557-7.385-5.358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61C8F2",
    d: "M7.385 42.701s1.703-.826 1.91-3.809c.568.576 2.023 4.2.018 7.877-.779-1.221-1.928-4.068-1.928-4.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F18700",
    d: "M3.437 29.281s-1.57.77-2.513-1.503 2.113-2.272 2.113-2.272-.03 2.7.4 3.775m11.667-2.789s1.455.456 1.705 1.796c.343 1.846-2.182 1.92-2.319 1.918 0 0 .652-2.615.614-3.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M4.472 33.077s1.244 3.354 5.546 3.354c2.281 0 4.54-4.308 4.54-4.308 1.788-4.555 1.05-10.183 1.02-10.161-2.092 1.535-4.097 1.515-9.157-.183-1.345-.451-3.655-1.594-3.655-1.594S.12 24.509 4.472 33.077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M5.285 30.022a.984.984 0 1 1 .26-1.952.984.984 0 0 1-.26 1.952"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61C8F2",
    d: "M55.13 27.7a.984.984 0 1 1-1.952-.26.984.984 0 0 1 1.952.26m-8.367 1.197a.738.738 0 1 1-1.464-.195.738.738 0 0 1 1.464.195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M14.918 29.532a.738.738 0 1 1 .195-1.464.738.738 0 0 1-.195 1.464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    d: "m49.723 22.646-1.477 6.944 1.477.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F18700",
    d: "m9.909 25.6-.555 2.954h1.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B304B",
    d: "M21.62 43.637C7.02 48.756 5.274 49.23 3.34 49.23c-1.483 0-4.728-4.03.538-5.716 4.159-1.332 12.61-3.26 15.78-4.163 3.168-.902 8.004-9.605 10.451-11.165 1.129-.718 1.399 1.873 1.399 1.873s-6.439 12.367-9.889 13.577Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F18700",
    d: "M33.477 29.151s6.86 12.764 10.09 14.573 13.28 6.14 15.842 7.312c2.775 1.269 6.33.77 6.915-2.138.915-4.55-2.896-5.761-6.544-6.147-3.311-.35-10.014-3.36-12.189-4.351-2.174-.991-12.862-13.292-12.862-13.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    d: "M8.862 26.338a.738.738 0 1 1-1.477 0 .738.738 0 0 1 1.477 0m6.4 0a.738.738 0 1 1-1.477 0 .738.738 0 0 1 1.477 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B304B",
    d: "M50.735 32.492c-.135 0-.244-.079-.244-.176q0-.098-.276-1.124c.721 0 5.53-.177 5.665-.177s.243.08.243.177c0 .717-.805 1.3-1.794 1.3zM8.724 23.183c-.235-.09-.774-.022-1.015.017a.16.16 0 0 0-.09.014l-.297.134c-.162.073-.573.348-.378.438.555.256 1.073.052 1.78.333.185.073.181-.867 0-.936m5.053.109c-.131-.182-1.289-.264-1.378-.14-.08.112-.076.655.046.636.501-.076 1.695.594 1.723.5.034-.118-.33-.913-.391-.996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    d: "M49.928 18.887a17 17 0 0 0-3.543.2c-.26.042-.16.696.069.693a36 36 0 0 1 3.26.103c.23.018.396-.575.45-.71.06-.15-.05-.277-.236-.286m7.447 2.103a18.4 18.4 0 0 0-4.22-1.623c-.146-.037-.28.087-.299.2v.003c-.003.02-.027.037-.03.06l-.053.279-.003.006-.006.018h.003c-.006.102.058.176.145.214.022.088 2.835 1.245 3.914 1.78a.26.26 0 0 0 .286-.03c.066 0 .13-.026.18-.088a.97.97 0 0 0 .247-.566c.011-.113-.054-.193-.164-.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E7",
    d: "M31.295 24.897s-3.2-2.606-2.685-3.346 2.12 1.89 2.84 1.317c.72-.574-1.37-5.754-.722-7.243.65-1.489 1.253 2.05 1.429 2.44.455 1.008.264-2.193 1.714-2.537 1.278-.304-.88 2.997-.279 4.051.602 1.055.3-2.354 2.648-2.485.591-.033-2.115 3.709-1.626 4.49.488.78 1.662-3.628 2.801-1.926 0 0-1.575 3.195-1.765 4.203s-.071 4.55-2.574 5.135-1.78-4.1-1.78-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M31.16 18.024c.179-1.41-.353-1.778-.353-1.778s-.552 2.166-.837 5.345l-.003.041c-.292-.373-.628-.663-.707-.309-.067.301.27 1.095.637 1.836.563 3.603-1.734 5.766-.46 6.294 2.047.85 3.97-4.897 3.467-6.454-.463-1.432-.657-1.16-.521-3.113.136-1.952-1.4-.45-1.222-1.862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DCD",
    d: "M8.862 14.794c-2.217.524-5.836-1.815-9.53 4.252-1.474 2.421-1.358 4.141-4.255 10.492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B314B",
    d: "M26.782 15.754a.29.29 0 0 1-.237-.132l-.886-1.314a.35.35 0 0 1 .06-.458.277.277 0 0 1 .413.066l.886 1.315a.35.35 0 0 1-.06.458.28.28 0 0 1-.176.065M32 12.308c-.272 0-.492-.186-.492-.416v-3.6c0-.229.22-.415.492-.415s.492.186.492.415v3.6c0 .23-.22.416-.492.416m5.857 3.446a.44.44 0 0 1-.31-.126.433.433 0 0 1-.005-.617l3.055-3.065a.445.445 0 0 1 .625-.005c.174.17.176.445.005.617l-3.055 3.065a.44.44 0 0 1-.315.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DCD",
    d: "M4.785 16.738q.936 6.516-2.067 8.473Q-.283 27.167.62 21.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B314B",
    d: "M7.752 31.026q2.774.493 4.832.083a.45.45 0 0 1 .464.689 2.45 2.45 0 0 1-1.844 1.097l-2.023.171q-2.51-1.405-1.429-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1B304B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M53.17 25.108c0-.544.33-.985.738-.985s.738.44.738.985M46.77 23.63c0-.543.33-.984.738-.984s.738.441.738.985"
  })))));
};
export default SvgNetworking;